// Pomocnicze reguły chipów wyszukiwarki. Od 6.10 (układ filtrów Maćka) to, które filtry widać
// i gdzie, liczy `src/lib/rzadFiltrow.ts`; tu zostało porządkowanie podpowiedzi przy pustym wyniku.

/**
 * CO POLUZOWAĆ przy pustym wyniku z „Mojego wyszukiwania": kandydaci uporządkowani od tego,
 * którego zdjęcie przynosi najwięcej ofert. Kandydat, który nic nie daje (0 albo liczba jeszcze
 * nieznana), nie jest pokazywany — przycisk, po którym dalej jest pusto, byłby fałszywą obietnicą.
 * Najwyżej `maks` pozycji.
 */
export function uporzadkujPoluzowanie<T>(kandydaci: T[], liczby: (number | null | undefined)[], maks = 4): T[] {
  return kandydaci
    .map((k, i) => ({ k, ile: liczby[i] ?? 0 }))
    .filter((x) => x.ile > 0)
    .sort((a, b) => b.ile - a.ile)
    .slice(0, maks)
    .map((x) => x.k);
}
